import VetQuestApi from "./VetQuestApi";
import { ResponseModel, IStateModel, IUserModel } from "@/models";

export abstract class UserService {
  static BASE: string = "users";

  static async GetAuthenticationMethod(): Promise<ResponseModel<string>> {
    let response = new ResponseModel<string>(0, "");
    try {
      const { data, status } = await VetQuestApi().get(
        `${this.BASE}/authenticationmethod`
      );
      if (status === 200) {
        response.status = 200;
        response.data = data;
      }
    } catch (err) {
      response.status = err.response.status;
      response.error = err.response;
    }
    return response;
  }

  static async GetAuthorizeUrl(
    // TFS # 25551 ~ being logged in is resulting in an errant redirect to login due to this force=true setting
    //               so we're setting this to false until a better / permanent fix is found
    force: boolean = false
  ): Promise<ResponseModel<string>> {
    let response = new ResponseModel<string>(0, "");
    try {
      const { data, status } = await VetQuestApi().get(
        `${this.BASE}/authorizeurl?force=${force}`
      );
      if (status === 200) {
        response.status = 200;
        response.data = data;
      }
    } catch (err) {
      response.status = err.response.status;
      response.error = err.response;
    }
    return response;
  }
  static async GetAuthorizeCode(code: string): Promise<ResponseModel<string>> {
    let response = new ResponseModel<string>(0, "");
    try {
      const { data, status } = await VetQuestApi().get(
        `${this.BASE}/authorizecode?code=${code}`
      );
      if (status === 200) {
        response.status = 200;
        response.data = data;
      }
    } catch (err) {
      const result = err.response !== undefined ? err.response : err;
      response.status = result.status;
      response.error = result;
    }
    return response;
  }

  static async Logout(): Promise<ResponseModel<boolean>> {
    let response = new ResponseModel<boolean>(0, false);
    try {
      const { data, status } = await VetQuestApi().get(`${this.BASE}/logout`);
      if (status === 200) {
        response.status = 200;
        response.data = data;
      }
    } catch (err) {
      response.status = err.response.status;
      response.error = err.response;
    }
    return response;
  }

  static async IsAuthenticated() {
    let response = new ResponseModel<boolean>(0, false);
    try {
      const { data, status } = await VetQuestApi().get(
        `${this.BASE}/authenticated`
      );
      if (status === 200) {
        response.status = 200;
        response.data = data;
      }
    } catch (err) {
      response.status = err.response.status;
      response.error = err.response;
    }
    return response;
  }

  static async GetUserLoginInfo(): Promise<ResponseModel<IUserModel>> {
    let response = new ResponseModel<IUserModel>(0, {} as IUserModel);
    try {
      response = await VetQuestApi().get(`${this.BASE}/current`);
    } catch (e) {
      response = e;
    }
    return response;
  }
}
